import React from 'react';
import { MessageSquareIcon } from 'lucide-react';
import { smsLink } from '../utils/sms';
type Variant = 'primary' | 'ink' | 'outline' | 'onDark';
type Size = 'sm' | 'md' | 'lg';
interface TextButtonProps {
  message: string;
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  className?: string;
  showIcon?: boolean;
}
const variants: Record<Variant, string> = {
  primary: 'bg-aqua-600 text-white hover:bg-aqua-700 active:bg-aqua-700 shadow-card',
  ink: 'bg-ink-950 text-white hover:bg-ink-900 active:bg-ink-900',
  outline: 'border border-ink-950/15 bg-white text-ink-950 hover:border-ink-950/35 hover:bg-canvas',
  onDark: 'bg-white text-ink-950 hover:bg-aqua-100'
};
const sizes: Record<Size, string> = {
  sm: 'px-4 py-2 text-[13px]',
  md: 'px-5 py-3 text-sm',
  lg: 'px-7 py-3.5 text-[15px]'
};
export function TextButton({
  message,
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  showIcon = true
}: TextButtonProps) {
  return <a href={smsLink(message)} className={`inline-flex items-center justify-center gap-2 rounded-full font-medium transition-colors duration-150 ease-smooth ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-239" data-mp="1gikj3emycnse">
      {showIcon && <MessageSquareIcon className="h-4 w-4" aria-hidden="true" data-id="element-240" data-mp="1q9f6imbxptff" />}
      <span data-id="element-241" data-mp="1lhf2ahou0ed1">{children}</span>
    </a>;
}